//Komen-Waasten
import Front from "../../../images/Services/Exterieur/Exterieur.webp";
import before2 from "../../../images/References/Exterieur/Komen-waasten/before/A2.webp";
import before3 from "../../../images/References/Exterieur/Komen-waasten/before/A3.webp";
import before4 from "../../../images/References/Exterieur/Komen-waasten/before/A4.webp";
import after1 from "../../../images/References/Exterieur/Komen-waasten/after/B1.webp";
import after2 from "../../../images/References/Exterieur/Komen-waasten/after/B2.webp";
import after3 from "../../../images/References/Exterieur/Komen-waasten/after/B3.webp";
import after4 from "../../../images/References/Exterieur/Komen-waasten/after/B4.webp";
//Interieur Bissegem
import Bissegem from "../../../images/References/Interieur/Bissegem/Bissegem.webp";
import Bissegem2 from "../../../images/References/Interieur/Bissegem/A2.webp";
import Bissegem3 from "../../../images/References/Interieur/Bissegem/A3.webp";
//Interieur Gullegem
import Gullegem from "../../../images/References/Interieur/Gullegem/Gullegem2.webp";
import Gullegem2 from "../../../images/References/Interieur/Gullegem/Gullegem.webp";
import Gullegem3 from "../../../images/References/Interieur/Gullegem/A1.webp";
import Gullegem4 from "../../../images/References/Interieur/Gullegem/A2.webp";
import Gullegem5 from "../../../images/References/Interieur/Gullegem/A3.webp";
import Gullegem6 from "../../../images/References/Interieur/Gullegem/A4.webp";
import Gullegem7 from "../../../images/References/Interieur/Gullegem/A5.webp";
import Gullegem8 from "../../../images/References/Interieur/Gullegem/A6.webp";
import Gullegem9 from "../../../images/References/Interieur/Gullegem/A7.webp";

//Interieur Harelbeke
import Harelbeke from "../../../images/References/Interieur/Harelbeke/Harelbeke2.webp";
import Harelbeke2 from "../../../images/References/Interieur/Harelbeke/Harelbeke.webp";
import Harelbeke3 from "../../../images/References/Interieur/Harelbeke/A1.webp";
import Harelbeke4 from "../../../images/References/Interieur/Harelbeke/A2.webp";
import Harelbeke5 from "../../../images/References/Interieur/Harelbeke/A3.webp";
import Harelbeke6 from "../../../images/References/Interieur/Harelbeke/A4.webp";
import Harelbeke7 from "../../../images/References/Interieur/Harelbeke/A5.webp";
import Harelbeke8 from "../../../images/References/Interieur/Harelbeke/A7.webp";
import Harelbeke9 from "../../../images/References/Interieur/Harelbeke/A8.webp";
import Harelbeke10 from "../../../images/References/Interieur/Harelbeke/A9.webp";
import Harelbeke11 from "../../../images/References/Interieur/Harelbeke/A10.webp";

//Interieur Kortrijk Frituur Natuur
import Kortrijk from "../../../images/References/Interieur/Kortrijk-FrituurNatuur/FrituurNatuur.webp";
import Kortrijk2 from "../../../images/References/Interieur/Kortrijk-FrituurNatuur/A1.webp";
import Kortrijk3 from "../../../images/References/Interieur/Kortrijk-FrituurNatuur/A2.webp";
import Kortrijk4 from "../../../images/References/Interieur/Kortrijk-FrituurNatuur/A3.webp";
import Kortrijk5 from "../../../images/References/Interieur/Kortrijk-FrituurNatuur/A4.webp";
import Kortrijk6 from "../../../images/References/Interieur/Kortrijk-FrituurNatuur/A5.webp";
import Kortrijk7 from "../../../images/References/Interieur/Kortrijk-FrituurNatuur/A7.webp";

//Interieur Kortrijk Frituur Natuur
import Kortrijk6425 from "../../../images/References/Interieur/Kortrijk6425/KORTRIJK.jpg";
import Kortrijk64251 from "../../../images/References/Interieur/Kortrijk6425/KORTRIJK2.jpg";
import Kortrijk64252 from "../../../images/References/Interieur/Kortrijk6425/KORTRIJK3.jpg";
import Kortrijk64253 from "../../../images/References/Interieur/Kortrijk6425/KORTRIJK4.jpg";
import Kortrijk64254 from "../../../images/References/Interieur/Kortrijk6425/KORTRIJK5.jpg";




//Exterieur Harlbeke
import ExHarelbeke from "../../../images/References/Exterieur/Harelbeke/AE1.webp";
import ExHarelbeke2 from "../../../images/References/Exterieur/Harelbeke/AE2.webp";
import ExHarelbeke3 from "../../../images/References/Exterieur/Harelbeke/AE3.webp";

//Onbekend Exterieur
import OnbekendExterieur from "../../../images/References/Exterieur/Onbekend/onbekend.webp";
import OnbekendExterieur2 from "../../../images/References/Exterieur/Onbekend/A1.webp";
import OnbekendExterieur3 from "../../../images/References/Exterieur/Onbekend/A2.webp";
import OnbekendExterieur4 from "../../../images/References/Exterieur/Onbekend/A3.webp";
import OnbekendExterieur5 from "../../../images/References/Exterieur/Onbekend/A4.webp";
import OnbekendExterieur6 from "../../../images/References/Exterieur/Onbekend/A5.webp";
//Wevelgem Exterieur
import WevelgemEx from "../../../images/References/Exterieur/Wevelgem/Wevelgem.webp";
import WevelgemEx2 from "../../../images/References/Exterieur/Wevelgem/Wevelgem2.webp";
import WevelgemEx3 from "../../../images/References/Exterieur/Wevelgem/A1.webp";

//Wevelgem2 Interieur
import WevelgemIn from "../../../images/References/Interieur/Wevelgem/A1.webp";
import WevelgemIn3 from "../../../images/References/Interieur/Wevelgem/A3.webp";
import WevelgemIn4 from "../../../images/References/Interieur/Wevelgem/A4.webp";
import WevelgemIn5 from "../../../images/References/Interieur/Wevelgem/A5.webp";
import WevelgemIn6 from "../../../images/References/Interieur/Wevelgem/A6.webp";
import WevelgemIn7 from "../../../images/References/Interieur/Wevelgem/A7.webp";
import WevelgemIn8 from "../../../images/References/Interieur/Wevelgem/A8.webp";
import WevelgemIn9 from "../../../images/References/Interieur/Wevelgem/A9.webp";
import WevelgemIn10 from "../../../images/References/Interieur/Wevelgem/A10.webp";

//Marke Behangen
import MarkeBe from "../../../images/References/Behangen/Marke/A1.webp";
import MarkeBe2 from "../../../images/References/Behangen/Marke/A2.webp";

//Ruiselede Behangen
import Ruiselede from "../../../images/References/Behangen/Ruiselede/ruiselede1.jpg";
import Ruiselede2 from "../../../images/References/Behangen/Ruiselede/ruiselede2.jpg";
import Ruiselede3 from "../../../images/References/Behangen/Ruiselede/ruiselede3.jpg";
import Ruiselede4 from "../../../images/References/Behangen/Ruiselede/ruiselede4.jpg";
import Ruiselede5 from "../../../images/References/Behangen/Ruiselede/ruiselede5.jpg";

//Ruiselede Behangen
import Kruisem from "../../../images/References/Decoratieve technieken/AquaSensa-Kruisem/kruisem.jpg";
import Kruisem2 from "../../../images/References/Decoratieve technieken/AquaSensa-Kruisem/kruisem2.jpg";
import Kruisem3 from "../../../images/References/Decoratieve technieken/AquaSensa-Kruisem/kruisem3.jpg";
import Kruisem4 from "../../../images/References/Decoratieve technieken/AquaSensa-Kruisem/kruisem4.jpg";
import Kruisem5 from "../../../images/References/Decoratieve technieken/AquaSensa-Kruisem/kruisem5.jpg";

//Porducts
import Elasto from "../../../images/References/Exterieur/Komen-waasten/elasto.png";
import Matineau from "../../../images/References/Exterieur/Harelbeke/matineau.webp";
import BossflowSilk from "../../../images/References/Interieur/Wevelgem/silk.webp";
import PlafondMat from "../../../images/References/Interieur/Wevelgem/plafondmat.webp";
import Claystuc from "../../../images/References/Interieur/Gullegem/claystuc.webp";
import BossFlowMat from "../../../images/References/products/bossflowmat.webp";
import Persisto from "../../../images/References/products/persisto.webp";
import AquaSensaPoeder from "../../../images/References/products/aquasensa-poeder.webp";
import AquaSensaBindmiddel from "../../../images/References/products/aquasensa-bindmiddel.webp";
import OmniprimExtreme from "../../../images/References/products/Omniprim-extreme.webp";
import Bolatex from "../../../images/References/products/bolatex.webp";
import Pastime from "../../../images/References/products/pastime.webp";
import Sublimat from "../../../images/References/products/sublimat.webp";
import Subliprim from "../../../images/References/products/subliprim-30.png";

//Project trap Harelbeke
import HarelbekeInterier from "../../../images/References/Interieur/harelbeke3/6.webp";
import HarelbekeInterier2 from "../../../images/References/Interieur/harelbeke3/5.webp";
import HarelbekeInterier3 from "../../../images/References/Interieur/harelbeke3/4.webp";
import HarelbekeInterier4 from "../../../images/References/Interieur/harelbeke3/3.webp";
import HarelbekeInterier5 from "../../../images/References/Interieur/harelbeke3/2.webp";
import HarelbekeInterier6 from "../../../images/References/Interieur/harelbeke3/1.webp";

//Aqua Sensa Bissegem
import ASBissegem from "../../../images/References/Decoratieve technieken/AquaSensa-Bissegem/1.webp";
import ASBissegem2 from "../../../images/References/Decoratieve technieken/AquaSensa-Bissegem/2.webp";
import ASBissegem3 from "../../../images/References/Decoratieve technieken/AquaSensa-Bissegem/3.webp";
import ASBissegem4 from "../../../images/References/Decoratieve technieken/AquaSensa-Bissegem/4.webp";
import ASBissegem5 from "../../../images/References/Decoratieve technieken/AquaSensa-Bissegem/5.webp";
import ASBissegem6 from "../../../images/References/Decoratieve technieken/AquaSensa-Bissegem/6.webp";

//Houtwerk Kuurne
import Kuurne from "../../../images/References/Interieur/Kuurne/1.webp";
import Kuurne2 from "../../../images/References/Interieur/Kuurne/2.webp";
import Kuurne3 from "../../../images/References/Interieur/Kuurne/3.webp";
import Kuurne4 from "../../../images/References/Interieur/Kuurne/4.webp";

//Houtwerk Kuurne
import houtwerkKortrijk from "../../../images/References/Interieur/houtwerk-kortrijk/1.webp";
import houtwerkKortrijk2 from "../../../images/References/Interieur/houtwerk-kortrijk/2.webp";
import houtwerkKortrijk3 from "../../../images/References/Interieur/houtwerk-kortrijk/3.webp";
import houtwerkKortrijk4 from "../../../images/References/Interieur/houtwerk-kortrijk/4.webp";
import houtwerkKortrijk5 from "../../../images/References/Interieur/houtwerk-kortrijk/5.webp";
import houtwerkKortrijk6 from "../../../images/References/Interieur/houtwerk-kortrijk/6.webp";
import houtwerkKortrijk7 from "../../../images/References/Interieur/houtwerk-kortrijk/7.webp";
import houtwerkKortrijk8 from "../../../images/References/Interieur/houtwerk-kortrijk/8.webp";
import houtwerkKortrijk9 from "../../../images/References/Interieur/houtwerk-kortrijk/9.webp";

// Exterieur - Oostend 14/05
import OostendeEx from "../../../images/References/Exterieur/Oostende/3hor.webp";
import OostendeEx2 from "../../../images/References/Exterieur/Oostende/2hor.webp";
import OostendeEx4 from "../../../images/References/Exterieur/Oostende/4hor.webp";
import OostendeEx5 from "../../../images/References/Exterieur/Oostende/5hor.webp";
import OostendeEx6 from "../../../images/References/Exterieur/Oostende/6hor.webp";
import OostendeEx7 from "../../../images/References/Exterieur/Oostende/10ver.webp";
import OostendeEx9 from "../../../images/References/Exterieur/Oostende/9hor.webp";
import OostendeEx10 from "../../../images/References/Exterieur/Oostende/12hor.webp";

// Exterieur - Harelbeke 28/08
import harelebek2408Ex1 from "../../../images/References/Exterieur/Harelbeke2/1.webp";
import harelebek2408Ex2 from "../../../images/References/Exterieur/Harelbeke2/2.webp";
import harelebek2408Ex3 from "../../../images/References/Exterieur/Harelbeke2/3.webp";
import harelebek2408Ex4 from "../../../images/References/Exterieur/Harelbeke2/4.webp";
import harelebek2408Ex5 from "../../../images/References/Exterieur/Harelbeke2/5.webp";
import harelebek2408Ex6 from "../../../images/References/Exterieur/Harelbeke2/6.webp";
import harelebek2408Ex7 from "../../../images/References/Exterieur/Harelbeke2/7.webp";
import harelebek2408Ex8 from "../../../images/References/Exterieur/Harelbeke2/8.webp";

// Vloeren Nieuwpoort
import Nieuwpoort1 from "../../../images/References/Vloeren/nieuwpoort1.jpg";
import Nieuwpoort3 from "../../../images/References/Vloeren/nieuwpoort3.jpg";
import Nieuwpoort4 from "../../../images/References/Vloeren/nieuwpoort4.jpg";
import Nieuwpoort5 from "../../../images/References/Vloeren/nieuwpoort5.jpg";

// Interieur Nieuwpoort
import Nieuwpoort from "../../../images/References/Interieur/Nieuwpoort/nieuwpoort.jpg";
import Nieuwpoort6 from "../../../images/References/Interieur/Nieuwpoort/nieuwpoort6.jpg";
import Nieuwpoort7 from "../../../images/References/Interieur/Nieuwpoort/nieuwpoort7.jpg";
import Nieuwpoort8 from "../../../images/References/Interieur/Nieuwpoort/nieuwpoort8.jpg";
import Nieuwpoort9 from "../../../images/References/Interieur/Nieuwpoort/nieuwpoort9.jpg";
import Nieuwpoort10 from "../../../images/References/Interieur/Nieuwpoort/nieuwpoort10.jpg";

const References = [
  {
    id: 1,
    priority: false,
    url: "Exterieur-Komen-waasten",
    image: Front,
    category: "exterieur",
    subject: "Exterieur",
    city: "Komen-Waasten",
    height: 35,
    defaultHeight: 25,
    title: "Schilderen voordeur",
    introText: "",

    techniques: [
      {
        id: 1,
        title: "Exterieur | Buiten Houtwerk",
        url: "/dienst/exterieur",
      },
      {
        id: 2,
        title: "Exterieur | Dakgoot schilderen",
        url: "/dienst/exterieur",
      },
    ],
    preferences: {
      customer: "niet van toepassing.",
      color: [],
      product: [
        {
          id: 1,
          title: "Bescherming",
          showProduct: true,
          productImage: Elasto,
          productName: "Elastosatin One",
          productInfo: "Grondlaag en afwerklak voor buitenafwerking op hout.",
        },
      ],

      goalChoice: {
        title: "Doel van keuze",
        text: "Het doel van de klant was om zowel duurzaamheid als esthetiek te waarborgen.",
        showGoalChoice: true,
      },
    },

    review: [
      {
        text: "",
        owner: "",
      },
    ],

    images: [
      {
        id: 1,
        image: after1,
      },
      {
        id: 2,
        image: before2,
      },
      {
        id: 3,
        image: after2,
      },
      {
        id: 4,
        image: before3,
      },
      {
        id: 5,
        image: after3,
      },
      {
        id: 6,
        image: before4,
      },
      {
        id: 7,
        image: after4,
      },
    ],
  },
  {
    id: 2,
    priority: false,
    url: "Interieur-Bissegem",
    image: Bissegem,
    category: "interieur",
    subject: "Interieur ",
    city: "Bissegem",
    height: 40,
    defaultHeight: 25,
    title: "Woning te Bissegem",
    techniques: [
      {
        id: 1,
        title: "Interieur | Schilderen van muren",
        url: "/diensten/interieur",
      },
      {
        id: 2,
        title: "Interieur | Plafond schilderen",
        url: "/diensten/interieur",
      },
    ],
    preferences: {
      customer:
        "De klant heeft muren met Bossflow Silk en het plafond met Boss Planfond Mat geschilderd voor een harmonieuze uitstraling. Geschikt materiaal en overweging van omgevingscondities zijn cruciaal voor een optimaal resultaat.",
      color: [],
      product: [
        {
          id: 1,
          title: "Afwerking",
          showProduct: true,
          productImage: BossflowSilk,
          productName: "Bossflow Silk",
          productInfo: "Hoogkwalitatieve afwerklaag voor binnenmuren.",
        },
        {
          id: 2,
          title: "Afwerking",
          showProduct: true,
          productImage: PlafondMat,
          productName: "Boss Planfond Mat",
          productInfo: "Extra matte afwerklaag voor plafonds.",
        },
      ],

      goalChoice: {
        title: "Doel van keuze",
        text: "Het doel van de klant was om zowel duurzaamheid als esthetiek te waarborgen.",
        showGoalChoice: false,
      },
    },
    review: [
      {
        text: "",
        owner: "",
      },
    ],

    images: [
      {
        id: 1,
        image: Bissegem,
      },
      {
        id: 2,
        image: Bissegem2,
      },
      {
        id: 3,
        image: Bissegem3,
      },
    ],
  },
  {
    id: 2,
    priority: false,
    url: "Interieur-Gullegem",
    image: Gullegem,
    category: "decoratieve technieken",
    subject: "decoratieve technieken ",
    city: "Gullegem",
    height: 30,
    defaultHeight: 25,
    title: "Kledingzaak in claystuc",
    introText: "test",

    techniques: [
      {
        id: 1,
        title: "Decoratieve Technieken | Claystuc",
        url: "/Decoratieve-technieken",
      },
    ],
    preferences: {
      customer: "test",
      color: [],
      product: [
        {
          id: 1,
          title: "Afwerking",
          showProduct: true,
          productImage: Claystuc,
          productName: "Claystuc",
          productInfo:
            "Decoratieve stuctechniek op basis van klei en minerale additieven.",
        },
      ],

      goalChoice: {},
    },
    review: [
      {
        text: "",
        owner: "",
      },
    ],

    images: [
      {
        id: 1,
        image: Gullegem,
      },
      {
        id: 2,
        image: Gullegem2,
      },
      {
        id: 3,
        image: Gullegem3,
      },
      {
        id: 4,
        image: Gullegem4,
      },
      {
        id: 5,
        image: Gullegem5,
      },
      {
        id: 6,
        image: Gullegem6,
      },
      {
        id: 7,
        image: Gullegem7,
      },
      {
        id: 8,
        image: Gullegem8,
      },
      {
        id: 9,
        image: Gullegem9,
      },
    ],
  },
  {
    id: 3,
    priority: false,
    url: "Interieur-Wevelgem",
    image: WevelgemIn,
    category: "interieur",
    subject: "Interieur ",
    city: "Wevelgem",
    height: 30,
    defaultHeight: 25,
    title: "Woning in Wevelgem",

    introText:
      "In de wereld van huisdecoratie is het maken van de juiste keuzes essentieel om de gewenste sfeer en uitstraling te bereiken. Elke klant heeft zijn eigen unieke visie en voorkeuren bij het schilderen van hun huis, waarbij zowel esthetische als functionele aspecten een rol spelen.",

    techniques: [
      {
        id: 1,
        title: "Interieur | Schilderen van muren",
        url: "/diensten/interieur",
      },
      {
        id: 2,
        title: "Interieur | Plafond schilderen",
        url: "/diensten/interieur",
      },
    ],
    preferences: {
      customer:
        "De klant heeft gekozen voor schilderen van muren met Bossflow Silk en het plafond met Boss Planfond Mat voor een harmonieuze uitstraling. Geschikt materiaal en overweging van omgevingscondities zijn cruciaal voor een optimaal resultaat.",
      color: [],
      product: [
        {
          id: 1,
          title: "Afwerking",
          showProduct: true,
          productImage: BossflowSilk,
          productName: "Bossflow Silk",
          productInfo: "Hoogkwalitatieve afwerklaag voor binnenmuren.",
        },
        {
          id: 2,
          title: "Afwerking",
          showProduct: true,
          productImage: PlafondMat,
          productName: "Boss Planfond Mat",
          productInfo: "Extra matte afwerklaag voor plafonds.",
        },
      ],
    },
    review: [
      {
        text: "Mijn verouderde inrichting was aan vernieuwing toe. Zelf schilderen was geen optie dus op zoek naar een schilder. Gelukkig via mond op mond reclame contact genomen met Decoratie Degezelle wat een schot in de roos blijkt te zijn. Strakke planning, goeie begeleiding, mooie afgewerkte schilderwerken en een zeer eerlijke prijs voor dit alles. Mijn living is een pareltje geworden. Bedankt Alexandro",
        owner: "Peggy Herrisen - eigenaresse",
      },
    ],
    images: [
      {
        id: 1,
        image: WevelgemIn9,
      },
      {
        id: 2,
        image: WevelgemIn3,
      },
      {
        id: 3,
        image: WevelgemIn4,
      },
      {
        id: 4,
        image: WevelgemIn5,
      },
      {
        id: 5,
        image: WevelgemIn6,
      },
      {
        id: 6,
        image: WevelgemIn7,
      },
      {
        id: 7,
        image: WevelgemIn8,
      },
      {
        id: 8,
        image: WevelgemIn9,
      },
      {
        id: 9,
        image: WevelgemIn10,
      },
    ],
  },
  {
    id: 4,
    priority: false,
    url: "Interieur-Harelbeke",
    image: Harelbeke,
    category: "interieur",
    subject: "Interieur ",
    city: "Harelbeke",
    height: 30,
    defaultHeight: 25,
    title: "Project in Harelbeke",
    introText: "",

    techniques: [
      {
        id: 1,
        title: "Interieur | Schilderen van muren",
        url: "/diensten/interieur",
      },
      {
        id: 2,
        title: "Interieur | Plafond schilderen",
        url: "/diensten/interieur",
      },
    ],
    preferences: {
      customer: "niet van toepassing.",
      color: [],
      product: [
        {
          id: 1,
          title: "Afwerking",
          showProduct: true,
          productImage: BossflowSilk,
          productName: "Bossflow Silk",
          productInfo: "Hoogkwalitatieve afwerklaag voor binnenmuren.",
        },
        {
          id: 2,
          title: "Afwerking",
          showProduct: true,
          productImage: PlafondMat,
          productName: "Boss Planfond Mat",
          productInfo: "Extra matte afwerklaag voor plafonds.",
        },
      ],
    },
    review: [
      {
        text: "",
        owner: "",
      },
    ],

    images: [
      {
        id: 1,
        image: Harelbeke2,
      },
      {
        id: 2,
        image: Harelbeke3,
      },
      {
        id: 3,
        image: Harelbeke4,
      },
      {
        id: 4,
        image: Harelbeke5,
      },
      {
        id: 5,
        image: Harelbeke6,
      },
      {
        id: 6,
        image: Harelbeke7,
      },
      {
        id: 7,
        image: Harelbeke8,
      },
      {
        id: 8,
        image: Harelbeke9,
      },
      {
        id: 9,
        image: Harelbeke10,
      },
      {
        id: 10,
        image: Harelbeke9,
      },
      {
        id: 11,
        image: Harelbeke11,
      },
    ],
  },
  {
    id: 5,
    priority: false,
    url: "Interieur-Marke",
    image: Kortrijk,
    category: "interieur",
    subject: "Interieur ",
    city: "Marke",
    height: 30,
    defaultHeight: 25,
    title: "Frituur renovatie",
    introText: "",

    techniques: [
      {
        id: 1,
        title: "Interieur | Schilderen van muren",
        url: "/diensten/interieur",
      },
      {
        id: 2,
        title: "Interieur | Plafond schilderen",
        url: "/diensten/interieur",
      },
    ],
    preferences: {
      customer: "Snelle renovatie van hun frituur",
      color: [],
      product: [
        {
          id: 1,
          title: "Afwerking",
          showProduct: true,
          productImage: BossFlowMat,
          productName: "Bossflow mat",
          productInfo:
            "Hoogkwalitatieve afwerklaag voor binnenmuren en plafonds.",
        },
      ],

      goalChoice: [],
    },
    review: [
      {
        text: "",
        owner: "",
      },
    ],

    images: [
      {
        id: 1,
        image: Kortrijk2,
      },
      {
        id: 2,
        image: Kortrijk3,
      },
      {
        id: 3,
        image: Kortrijk4,
      },
      {
        id: 4,
        image: Kortrijk5,
      },
      {
        id: 5,
        image: Kortrijk6,
      },
      {
        id: 6,
        image: Kortrijk7,
      },
    ],
  },
  {
    id: 6,
    priority: false,
    url: "Exterieur-Zwevegem",
    image: OnbekendExterieur,
    category: "exterieur",
    subject: "Exterieur | Zwevegem",
    city: "Zwevegem",
    height: 35,
    defaultHeight: 25,
    title: "Buitenschilder project",
    introText: "",

    techniques: [
      {
        id: 1,
        title: "Exterieur | Gevel schilderen",
        url: "/diensten/exterieur",
      },
    ],
    preferences: {
      customer: "niet van toepassing",
      color: [],
      product: [
        {
          id: 1,
          title: "Bescherming",
          showProduct: true,
          productImage: Elasto,
          productName: "Elastosatin One",
          productInfo: "Grondlaag en afwerklak voor buitenafwerking op hout.",
        },
      ],

      goalChoice: {
        title: "Doel van keuze",
        text: "Het doel van de klant was om zowel duurzaamheid als esthetiek te waarborgen.",
        showGoalChoice: true,
      },
    },
    review: [
      {
        text: "",
        owner: "",
      },
    ],
    images: [
      {
        id: 1,
        image: OnbekendExterieur2,
      },
      {
        id: 2,
        image: OnbekendExterieur3,
      },
      {
        id: 3,
        image: OnbekendExterieur4,
      },
      {
        id: 4,
        image: OnbekendExterieur5,
      },
      {
        id: 5,
        image: OnbekendExterieur6,
      },
    ],
  },
  {
    id: 7,
    priority: false,
    url: "Exterieur-Wevelgem",
    image: WevelgemEx,
    category: "exterieur",
    subject: "Exterieur ",
    city: "Wevelgem",
    height: 35,
    defaultHeight: 25,
    title: "Project in Wevelgem",
    introText: "",
    techniques: [
      {
        id: 1,
        title: "Exterieur | Buiten Houtwerk",
        url: "/diensten/exterieur",
      },
    ],
    preferences: {
      customer: "niet van toepassing.  ",
      color: [],
      product: [
        {
          id: 1,
          title: "Grondlaag",
          showProduct: true,
          productImage: OmniprimExtreme,
          productName: "Omniprim Extreme",
          productInfo: "Grondlaag met extreme hechtingseigenschappen.",
        },
        {
          id: 1,
          title: "Bescherming",
          showProduct: true,
          productImage: Matineau,
          productName: "Matineau",
          productInfo: "Watergedragen matte acrylaatlak voor buiten.",
        },
      ],
    },
    review: [
      {
        text: "",
        owner: "",
      },
    ],

    images: [
      {
        id: 1,
        image: WevelgemEx2,
      },
      {
        id: 2,
        image: WevelgemEx3,
      },
    ],
  },
  {
    id: 8,
    priority: false,
    url: "Exterieur-Harelbeke",
    image: ExHarelbeke2,
    category: "exterieur",
    subject: "Exterieur ",
    city: "Harelbeke",
    height: 35,
    defaultHeight: 25,
    title: "Project in Harelbeke",
    introText:
      "Als klant heb je altijd de vrijheid om te kiezen wat het beste bij jouw behoeften en voorkeuren past. En in het geval van het schilderen van raamwerk buiten, heb we gekozen voor een verfproduct dat niet alleen esthetisch aantrekkelijk is, maar ook duurzaam en bestand tegen de elementen.",

    techniques: [
      {
        id: 1,
        title: "Exterieur | Buiten Houtwerk",
        url: "/diensten",
      },
      {
        id: 2,
        title: "Dakgoot schilderen",
        url: "/diensten",
      },
    ],
    preferences: {
      customer:
        "De klant heeft gekozen voor Matineau buitenlak, een duurzame en matte variant van Satineau, ideaal voor buiten. Voor het aanbrengen is aangepast materiaal nodig en moeten de weersomstandigheden in acht worden genomen voor het beste resultaat.",
      color: [],
      product: [
        {
          id: 1,
          title: "Bescherming",
          showProduct: true,
          productImage: Matineau,
          productName: "Matineau",
          productInfo: "Watergedragen matte acrylaatlak voor buiten.",
        },
      ],

      goalChoice: {
        title: "Doel van keuze",
        text: "Het doel van de klant was om zowel duurzaamheid als esthetiek te waarborgen.",
        showGoalChoice: false,
      },
    },
    review: [
      {
        text: "",
        owner: "",
      },
    ],

    images: [
      {
        id: 1,
        image: ExHarelbeke3,
      },
      {
        id: 2,
        image: ExHarelbeke,
      },
    ],
  },
  {
    id: 9,
    priority: false,
    url: "Behangwerken-Harelbeke",
    image: MarkeBe,
    category: "behangwerken",
    subject: "Behangwerken",
    city: "Harelbeke",
    height: 35,
    defaultHeight: 25,
    title: "Project in Harelbeke",
    introText: "",
    techniques: [
      {
        id: 1,
        title: "Behangwerken | Behangen met motief",
        url: "/diensten/behangwerken/#motief",
      },
    ],
    preferences: {
      customer: "test",
      color: [],
      product: [
        {
          id: 1,
          title: "Grondlaag/Afwerking",
          showProduct: true,
          productImage: Elasto,
          productName: "Elastosatin One",
          productInfo: "Grondlaag en afwerklak voor buitenafwerking op hout.",
        },
      ],

      goalChoice: {
        title: "Doel van keuze",
        text: "Het doel van de klant was om zowel duurzaamheid als esthetiek te waarborgen.",
        showGoalChoice: true,
      },
    },
    review: [
      {
        text: "Alexandro is een TOPKEREL, steeds behulpzaam,heeft oog voor detail,werkt met precizie,steeds vriendelijk, komt zijn beloftes na en zijn werk is zeker naar behoren gedaan en prachtig afgewerkt. Wij zijn heel tevreden met het resultaat en hij mag de rest van onze woning komen afwerken zoals beloofd.",
        owner: "Van Maldeghem Sandrine - eigenaresse",
      },
    ],

    images: [
      {
        id: 1,
        image: MarkeBe2,
      },
      {
        id: 2,
        image: MarkeBe,
      },
    ],
  },
  {
    id: 2,
    priority: true,
    url: "Interieur-Kortijk",
    image: Kortrijk6425,
    category: "interieur",
    subject: "Interieur ",
    city: "Kortrijk",
    height: 40,
    defaultHeight: 25,
    title: "Woning te Kortrijk",
    techniques: [
      {
        id: 1,
        title: "Interieur | Schilderen van muren",
        url: "/diensten/interieur",
      },
      {
        id: 2,
        title: "Interieur | Plafond schilderen",
        url: "/diensten/interieur",
      },
    ],
    preferences: {
      customer:
        "",
      color: [],
      product: [
        {
          id: 1,
          title: "Afwerking",
          showProduct: true,
          productImage: BossflowSilk,
          productName: "Bossflow Silk",
          productInfo: "Hoogkwalitatieve afwerklaag voor binnenmuren.",
        },
        {
          id: 2,
          title: "Afwerking",
          showProduct: true,
          productImage: PlafondMat,
          productName: "Boss Planfond Mat",
          productInfo: "Extra matte afwerklaag voor plafonds.",
        },
      ],

      goalChoice: {
        title: "Doel van keuze",
        text: "Het doel van de klant was om zowel duurzaamheid als esthetiek te waarborgen.",
        showGoalChoice: false,
      },
    },
    review: [
      {
        text: "",
        owner: "",
      },
    ],

    images: [
      {
        id: 1,
        image: Kortrijk64251,
      },
      {
        id: 2,
        image: Kortrijk64252,
      },
      {
        id: 3,
        image: Kortrijk64253,
      },
      {
        id: 4,
        image: Kortrijk64254,
      },
    ],
  },
  {
    id: 10,
    priority: true,
    url: "Aqua-Sensa-Kruisem",
    image: Kruisem,
    category: "decoratieve technieken",
    subject: "decoratieve technieken ",
    city: "Kruisem",
    height: 35,
    defaultHeight: 25,
    title: "badkamer in Aqua-Sensa.",
    techniques: [
      {
        id: 1,
        title: "Decoratieve Technieken | Aqua-Sensa",
        url: "/diensten/decoratieve%20technieken",
      },
    ],
    preferences: {
      customer: "Badkamer in Aqua-Sensa.",
      color: [],
      product: [
        {
          id: 1,
          title: "Afwerking",
          showProduct: true,
          productImage: AquaSensaPoeder,
          productName: "Aqua Sensa Poeder",
          productInfo:
            "Decoratieve waterbestendige afwerking voor binnenmuren en vloeren.",
        },
        {
          id: 2,
          title: "Afwerking",
          showProduct: true,
          productImage: AquaSensaBindmiddel,
          productName: "Aqua Sensa Bindmiddel",
          productInfo: "Toeslagstof voor Aqua Sensa poeder.",
        },
      ],
    },
    review: [
      {
        text: "",
        owner: "",
      },
    ],

    images: [
      {
        id: 1,
        image: Kruisem2,
      },
      {
        id: 2,
        image: Kruisem3,
      },
      {
        id: 3,
        image: Kruisem4,
      },
      {
        id: 4,
        image: Kruisem5,
      },
    ],
  },
  {
    id: 10,
    priority: true,
    url: "Behangen-Ruiselede",
    image: Ruiselede,
    category: "behangwerken",
    subject: "Behangen",
    city: "Ruiselede",
    height: 40,
    defaultHeight: 25,
    title: "Behangen van traphal.",
    techniques: [
      {
        id: 1,
        title: "Behangen | Traphal",
        url: "/diensten/behangen",
      },
    ],
    preferences: {
      customer: "",
      color: [],
      product: [],
    },
    review: [
      {
        text: "",
        owner: "",
      },
    ],

    images: [
      {
        id: 1,
        image: Ruiselede2,
      },
      {
        id: 2,
        image: Ruiselede3,
      },
      {
        id: 3,
        image: Ruiselede4,
      },
      {
        id: 4,
        image: Ruiselede5,
      },
    ],
  },
  {
    id: 11,
    priority: true,
    url: "Vloeren-Nieuwpoort",
    image: Nieuwpoort1,
    category: "vloeren",
    subject: "Vloeren",
    city: "Nieuwpoort",
    height: 35,
    defaultHeight: 25,
    title: "Vinyl vloer plinten en deurmat.",
    techniques: [
      {
        id: 1,
        title: "",
        url: "",
      },
    ],
    preferences: {
      customer: "",
      color: [],
      product: [],
    },
    review: [
      {
        text: "",
        owner: "",
      },
    ],

    images: [
      {
        id: 1,
        image: Nieuwpoort3,
      },
      {
        id: 2,
        image: Nieuwpoort4,
      },
      {
        id: 3,
        image: Nieuwpoort5,
      },
    ],
  },
  {
    id: 11,
    priority: true,
    url: "Interieur-Nieuwpoort",
    image: Nieuwpoort,
    category: "interieur",
    subject: "Interieur",
    city: "Nieuwpoort",
    height: 40,
    defaultHeight: 25,
    title: "Schilderen van woning.",
    techniques: [
      {
        id: 1,
        title: "",
        url: "",
      },
    ],
    preferences: {
      customer: "",
      color: [],
      product: [],
    },
    review: [
      {
        text: "",
        owner: "",
      },
    ],

    images: [
      {
        id: 1,
        image: Nieuwpoort6,
      },
      {
        id: 2,
        image: Nieuwpoort7,
      },
      {
        id: 4,
        image: Nieuwpoort8,
      },
      {
        id: 5,
        image: Nieuwpoort9,
      },
            {
        id: 6,
        image: Nieuwpoort10,
      },
    ],
  },
  {
    id: 11,
    priority: true,
    url: "Exterieur-Harelbeke2",
    image: harelebek2408Ex1,
    category: "exterieur",
    subject: "Exterieur",
    city: "Harelbeke",
    height: 30,
    defaultHeight: 25,
    title: "Schilderen van gevel",
    introText:
      "Met trots presenteren we onze nieuwste realisatie: In dit project hebben we het houtwerk en de buitengevel grondig onder handen genomen. Alles werd zorgvuldig geschuurd om een perfect gladde basis te creëren. Voor de gevel gebruikten we Subliprim wit als grondlaag en Sublimat wit als afwerklaag. Het houtwerk werd afgewerkt met twee lagen Elasto Satin One, drie duurzame en hoogwaardige verven die zorgen voor een prachtig eindresultaat en optimale bescherming. Het resultaat is een schitterende, strak afgewerkte look die zowel het houtwerk als de gevel weer als nieuw doet stralen! (29-08-2024)",
    techniques: [
      {
        id: 1,
        title: "Exterieur | Houtwerk",
        url: "/diensten/Exterieur",
      },
    ],
    preferences: {
      customer: "",
      color: [],
      product: [
        {
          id: 1,
          title: "Grondlaag/Afwerking",
          showProduct: true,
          productImage: Elasto,
          productName: "Elastosatin One",
          productInfo: "Grondlaag en afwerklak voor buitenafwerking op hout.",
        },
        {
          id: 2,
          title: "Afwerking",
          showProduct: true,
          productImage: Sublimat,
          productName: "Sublimat",
          productInfo: "Matte dispersieverf voor buitenmuren.",
        },
        {
          id: 3,
          title: "Grondlaag",
          showProduct: true,
          productImage: Subliprim,
          productName: "Subliprim",
          productInfo: "Dekkende watergedragen grondlaag voor buitenmuren.",
        },
      ],
    },
    review: [
      {
        text: "",
        owner: "",
      },
    ],

    images: [
      {
        id: 1,
        image: harelebek2408Ex2,
      },
      {
        id: 2,
        image: harelebek2408Ex3,
      },
      {
        id: 3,
        image: harelebek2408Ex4,
      },
      {
        id: 4,
        image: harelebek2408Ex5,
      },
      {
        id: 5,
        image: harelebek2408Ex6,
      },
      {
        id: 6,
        image: harelebek2408Ex7,
      },
      {
        id: 7,
        image: harelebek2408Ex8,
      },
    ],
  },
  {
    id: 12,
    priority: true,
    url: "Exterieur-Oostende",
    image: OostendeEx,
    category: "exterieur",
    subject: "Exterieur",
    city: "Oostende",
    height: 35,
    defaultHeight: 25,
    title: "Schilderen van houtwerk",
    introText:
      "Het is weer die tijd van het jaar! De lente is in volle gang en de zomer nadert snel, wat betekent dat het perfecte seizoen voor buitenschilderwerk is aangebroken. De milde temperaturen en langere dagen maken dit de ideale periode om uw huis of bedrijfspand een frisse, nieuwe uitstraling te geven. (14-05-2024)",
    techniques: [
      {
        id: 1,
        title: "Exterieur | Houtwerk",
        url: "/diensten/interieur",
      },
    ],
    preferences: {
      customer: "",
      color: [],
      product: [
        {
          id: 1,
          title: "Gevelafwerking",
          showProduct: true,
          productImage: Pastime,
          productName: "Pastime",
          productInfo:
            "Matte gekorrelde watergedragen gevelverf met kalei-uitzicht.",
        },
      ],
    },
    review: [
      {
        text: "",
        owner: "",
      },
    ],

    images: [
      {
        id: 1,
        image: OostendeEx2,
      },
      {
        id: 2,
        image: OostendeEx4,
      },
      {
        id: 3,
        image: OostendeEx5,
      },
      {
        id: 4,
        image: OostendeEx6,
      },
      {
        id: 5,
        image: OostendeEx7,
      },
      {
        id: 6,
        image: OostendeEx9,
      },
      {
        id: 7,
        image: OostendeEx10,
      },
    ],
  },
  {
    id: 13,
    priority: true,
    url: "Trap-Harelbeke",
    image: HarelbekeInterier,
    category: "interieur",
    subject: "Interieur",
    city: "Harelbeke",
    height: 35,
    defaultHeight: 25,
    title: "Trap te harelbeke",

    introText:
      "Ontdek onze recente traprealisatie in Harelbeke, waarbij we gebruik hebben gemaakt van Persisto Mat RAL 9005 verf. De bovenste trede is subtiel geaccentueerd met een woodcolor afwerking en matte vernis, waardoor een unieke uitstraling ontstaat.",

    techniques: [
      {
        id: 1,
        title: "Interieur | Houtwerk",
        url: "/diensten/interieur",
      },
    ],
    preferences: {
      customer:
        "De klant koos voor een opvallende twist door de bovenste trede in woodcolor te laten staan, die vervolgens is afgewerkt met een matte vernis. Deze keuze resulteerde in een unieke en persoonlijke uitstraling die perfect past bij het interieur van de klant.",
      color: [],
      product: [
        {
          id: 1,
          title: "Bescherming/afwerking",
          showProduct: true,
          productImage: Persisto,
          productName: "Persisto PU Mat",
          productInfo: "Matte afwerklak voor zeer krasvaste afwerking.",
        },
      ],
    },
    review: [
      {
        text: "",
        owner: "",
      },
    ],

    images: [
      {
        id: 1,
        image: HarelbekeInterier2,
      },
      {
        id: 2,
        image: HarelbekeInterier3,
      },
      {
        id: 3,
        image: HarelbekeInterier4,
      },
      {
        id: 4,
        image: HarelbekeInterier5,
      },
      {
        id: 5,
        image: HarelbekeInterier6,
      },
    ],
  },
  {
    id: 14,
    priority: true,
    url: "Aqua-sensa-Bissegem",
    image: ASBissegem,
    category: "decoratieve technieken",
    subject: "decoratieve technieken",
    city: "Bissegem",
    height: 35,
    defaultHeight: 25,
    title: "Badkamer in Aqua sensa",

    techniques: [
      {
        id: 1,
        title: "Interieur | Houtwerk",
        url: "/diensten/interieur",
      },
    ],
    preferences: {
      customer:
        "Met een vleugje verfrissende sereniteit heeft de klant gekozen om de badkamer te schilderen in Aqua Sensa. Deze tinten brengen rust en vernieuwing, en creëren een tijdloze esthetiek voor dagelijkse verjonging.",
      color: [],
      product: [
        {
          id: 1,
          title: "Afwerking",
          showProduct: true,
          productImage: AquaSensaPoeder,
          productName: "Aqua Sensa Poeder",
          productInfo:
            "Decoratieve waterbestendige afwerking voor binnenmuren en vloeren.",
        },
        {
          id: 2,
          title: "Afwerking",
          showProduct: true,
          productImage: AquaSensaBindmiddel,
          productName: "Aqua Sensa Bindmiddel",
          productInfo: "Toeslagstof voor Aqua Sensa poeder.",
        },
      ],
    },
    review: [
      {
        text: "Heel tevreden van het geleverde werk en advies inzake kleuren en er wordt gewerkt met de topprodukten van Boss.Er wordt proper gewerkt en ook opgekuist.Volgende project staat al vast 🙂Er wordt proper gewerkt en ook opgekuist.Volgende project staat al vast 🙂",
        owner: "Sabrina Bekaert - eigenaresse",
      },
    ],

    images: [
      {
        id: 1,
        image: ASBissegem2,
      },
      {
        id: 2,
        image: ASBissegem3,
      },
      {
        id: 3,
        image: ASBissegem4,
      },
      {
        id: 4,
        image: ASBissegem5,
      },
      {
        id: 5,
        image: ASBissegem6,
      },
    ],
  },
  {
    id: 15,
    priority: true,
    url: "houtwerk-Kuurne",
    image: Kuurne,
    category: "interieur",
    subject: "Interieur",
    city: "Kuurne",
    height: 35,
    defaultHeight: 25,
    title: "Schilderen van houtwerk",
    techniques: [
      {
        id: 1,
        title: "Interieur | Houtwerk",
        url: "/diensten/interieur",
      },
    ],
    preferences: {
      customer:
        "In project Te Kuurne laten we de keuze volledig aan de klant over. Het houtwerk is uitgevoerd in Persisto Mat RAL 9016, terwijl de muur is afgewerkt met Bolatex R9016. We streven ernaar om de wensen van onze klanten perfect te vervullen, tot in de kleinste details.",
      color: [],
      product: [
        {
          id: 1,
          title: "Bescherming/afwerking",
          showProduct: true,
          productImage: Persisto,
          productName: "Persisto PU Mat",
          productInfo: "Matte afwerklak voor zeer krasvaste afwerking.",
        },
        {
          id: 2,
          title: "Bescherming/afwerking",
          showProduct: true,
          productImage: Bolatex,
          productName: "Bolatex",
          productInfo: "Krasvaste lak voor houtwerk.",
        },
      ],
    },
    review: [
      {
        text: "Heel tevreden over het resultaat: goeie planning , snelle en duidelijke communicatie, fijne afwerking voor een eerlijke prijs .Alexandro kent zijn stiel en zouden we zeker aanraden. ",
        owner: "Koen Carpentier - eigenaar",
      },
    ],

    images: [
      {
        id: 1,
        image: Kuurne2,
      },
      {
        id: 2,
        image: Kuurne3,
      },
      {
        id: 3,
        image: Kuurne4,
      },
    ],
  },
  {
    id: 16,
    priority: true,
    url: "houtwerk-Kortrijk",
    image: houtwerkKortrijk,
    category: "interieur",
    subject: "Interieur",
    city: "Kortrijk",
    height: 35,
    defaultHeight: 25,
    title: "Schilderen van houtwerk",
    techniques: [
      {
        id: 1,
        title: "Interieur | Houtwerk",
        url: "/diensten/interieur",
      },
    ],
    preferences: {
      customer: "",
      color: [],
      product: [
        {
          id: 1,
          title: "Bescherming",
          showProduct: true,
          productImage: Elasto,
          productName: "Elastosatin One",
          productInfo: "Grondlaag en afwerklak voor buitenafwerking op hout.",
        },
      ],
    },
    review: [
      {
        text: "",
        owner: "",
      },
    ],

    images: [
      {
        id: 1,
        image: houtwerkKortrijk3,
      },
      {
        id: 2,
        image: houtwerkKortrijk2,
      },
      {
        id: 3,
        image: houtwerkKortrijk4,
      },
      {
        id: 4,
        image: houtwerkKortrijk5,
      },
      {
        id: 5,
        image: houtwerkKortrijk6,
      },
      {
        id: 6,
        image: houtwerkKortrijk7,
      },
      {
        id: 7,
        image: houtwerkKortrijk8,
      },
      {
        id: 8,
        image: houtwerkKortrijk9,
      },
    ],
  },
];

export default References;
